import React, { createContext, useState, useEffect } from "react";
import { getEmergencyPatients } from "../services/getEmergencyPatients";
import { useValidToken } from "../../../hooks/useValidToken";

export const EmergencyContext = createContext();

export const EmergencyProvider = ({ children }) => {
  const [emergencyPatients, setEmergencyPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [locationId, setLocationId] = useState(null);
  const [memberType, setMemberType] = useState(null);

  const { token, isValid, authLoading } = useValidToken();

  useEffect(() => {
    const fetchData = async () => {
      if (authLoading || !isValid) return;

      setLoading(true);
      setError(null);

      try {
        const data = await getEmergencyPatients(null, locationId, memberType);
        setEmergencyPatients(data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [authLoading, isValid, locationId, memberType]);

  return (
    <EmergencyContext.Provider value={{
      emergencyPatients,
      loading,
      error,
      setLocationId,
      setMemberType,
    }}>
      {children}
    </EmergencyContext.Provider>
  );
};
